module.exports = __webpack_public_path__ + "static/media/icon-11.fe654c03.png";